import { Directive, OnInit, OnDestroy } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-select[translocoSelect]'
})
export class TranslocoSelectDirective implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly ionSelect: IonSelect,
    private readonly translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.updateTranslations();

    this.translocoService.langChanges$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateTranslations();
      });
  }

  private updateTranslations(): void {
    this.ionSelect.cancelText =
      this.translocoService.translate('common.cancel');
    this.ionSelect.okText = this.translocoService.translate('common.ok');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
